<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12 vh-header d-flex flex-column">
        <div class="card flex-1-auto h-100 overflow-auto">
          <div class="card-header card-header-with-button">
               <h5>{{$t('OBJECTDETAILS')}}</h5>
               <button type="button" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
            </div>
            <div class="card-body" v-if="data.root == null || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="table-responsive h-100 flex-1-auto" v-if="data.root != null && data.root.length">
              <table class="table table-bis">
                <thead>
                  <tr>
                    <th>{{$t('NAME')}}</th>
                    <th>{{$t('ACTIONS')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in data.root">
                    <tr :key="item.objectDetailsId" aria-rowindex="1" class=" table-ellipsis">
                        <td>{{item.name}}</td>
                        <td class="table-buttons">
                          <b-button type="reset" class="btn-table table-btn-tertiary ml-2" @click="showModal(item)">{{$t('EDIT')}}</b-button>
                          <b-button type="reset" class="btn-table table-btn-delete ml-2" @click="deleteRow(item.objectDetailsId)">{{$t('DELETE')}}</b-button>
                        </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <pagination
                v-bind:totalCount="data.totalCount"
                v-model="pagination">
            </pagination>
          </div>
        </div>
    </div>
    <inputeditform v-model="formData" v-on:close="formData = null; getData()"></inputeditform>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import Api from '@/api/building_detail/ObjectDetails.js';
import InputEditForm from './ObjectDetailsForm.vue';

export default {
    name: 'BuildingObject',
    components:
    {
        inputeditform: InputEditForm,
    },
    data()
    {
        const me = this;


        return {
            loading: true,
            data: {},
            formError: {},
            formData: null,
            pagination: {
                query: '',
                currentPage: 1,
                limit: 25,
            },
            searchTimeout: false,
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      async getData()
      {
          const me = this;
          try
          {
              me.loading = true;
              const data = await Api.selectRow(me.getParams);
              if (data.error && data.error === true)
              {
                  throw (data);
              }
              me.data = data;
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
          finally
          {
              me.loading = false;
          }
      },
      async deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  async btnAction()
                  {
                      const data = await Api.deleteRow({ id });
                      me.$notify.notice(data);
                      me.getData();
                  },
              });
      },
      showModal(item)
      {
          const me = this;
          if (item == null)
          {
              item = {};
          }
          me.formData = { ...item };
      },
  },
    watch:
    {
        pagination:
        {
            deep: true,
            handler()
            {
                const me = this;

                if (me.searchTimeout !== false)
                {
                    clearTimeout(me.searchTimeout);
                }

                me.searchTimeout = setTimeout(() =>
                {
                    me.getData();
                    me.searchTimeout = false;
                }, 300);
            },
        },
    },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
